import { extractDisplayPrice } from '@travel-planner/shared/pricing';

export { extractDisplayPrice };

// Intentionally NOT consolidated into `@/shared/lib/format-price`: this copy
// has a distinct contract — it does NOT fall back to EUR for a missing/invalid
// currency (returns the unformatted number instead), normalises the code with
// trim()/toUpperCase(), and uses the runtime-default locale. Migrating it would
// change products list/detail output (e.g. `formatPrice(100, null)` -> `'€100'`).
export const formatPrice = (
  amount: number | null,
  currency: string | null
): string => {
  if (amount == null) return '—';
  const trimmed = (currency ?? '').trim();
  if (trimmed.length === 3) {
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: trimmed.toUpperCase(),
        maximumFractionDigits: 0,
      }).format(amount);
    } catch {
      // Fall through to the unformatted path on bad ISO codes.
    }
  }
  return amount.toLocaleString('en-US');
};
